// FEED SLIDER
const feedSections = document.querySelectorAll('.o-sec.feed');
if(feedSections.length > 0) {
  feedSections.forEach(function(sliderSection) {
    const slider = sliderSection.querySelector('.c-slider');
    const prevArrow = sliderSection.querySelector('.c-slider-arrows .c-slider-arrow.prev');
    const nextArrow = sliderSection.querySelector('.c-slider-arrows .c-slider-arrow.next');

    // INIT SLIDER
    const feedSlider = new Swiper(slider, {
      slidesPerView: 1.25,
      spaceBetween: 24,
      speed: 600,
      loop: true,
      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow,
      },
      allowTouchMove: false,
      breakpoints: {
        992: {
          slidesPerView: 2,
          spaceBetween: 56,
        }
      }
    });
  });
}